import React from "react";
import './index.css'

const DefaultScreen = ({title, description})=>{
    return(<div className="default-screeen-container">
        <div className="default-screeen-subcontainer">
            <p>{title}</p>
            <p className="default-screeen-subcontainer-description">{description}</p>


        </div>


    </div>)
}

export default DefaultScreen